import { render, staticRenderFns } from "./Person_no.vue?vue&type=template&id=a8260bf4&scoped=true"
import script from "./Person_no.vue?vue&type=script&lang=js"
export * from "./Person_no.vue?vue&type=script&lang=js"
import style0 from "./Person_no.vue?vue&type=style&index=0&id=a8260bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8260bf4",
  null
  
)

export default component.exports